import { FETCH_SUPPORT_REQUESTS } from './SupportActionTypes';
import { getSupportRequests } from '../../../services/SupportService';

// Async action creator for listing support requests
export const fetchSupportRequests = (currentPage, pageSize, searchTerm, filterQuery) => {
  return (dispatch) => {
    dispatch({ type: 'SUPPORT_REQUESTS_LOADING' });
    getSupportRequests(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
      dispatch({
        type: FETCH_SUPPORT_REQUESTS,
        payload: response.data.data,
      });
    }).finally(() => {
      dispatch({ type: 'SUPPORT_REQUESTS_LOADED' });
    });
  };
};
